import { ButtonHTMLAttributes, FC, memo, MouseEvent } from 'react';

import TextButton from '../Button/Text';

interface Props {
  btnName?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  onClose: () => void;
}

type NativeAttrs = Omit<ButtonHTMLAttributes<HTMLButtonElement>, keyof Props>;

export type ToastButtonProps = Props & NativeAttrs;

const ToastActionButton: FC<React.PropsWithChildren<React.PropsWithChildren<ToastButtonProps>>> = ({ onClick, onClose, btnName, ...props }) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (onClick) {
      onClick(event);
    }
    onClose();
  };
  return (
    <TextButton type="button" state="primary" onClick={handleClick} {...props}>
      {btnName}
    </TextButton>
  );
};

const MemoToastActionButton = memo(ToastActionButton);
export default MemoToastActionButton;
